module.exports = __webpack_public_path__ + "static/media/furnitures.13055bed.svg";